import { useTranslation } from 'react-i18next';
import BottomNav from "../components/BottomNav";
import { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { restitutionApi } from "../services/api";
import Logo from "../components/Logo";
import Button from "../components/Button";
import Input from "../components/Input";
import Callout from "../components/Callout";
import { OPERATORS } from "../constants";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A" };

export default function PayRestitution() {
  const { t } = useTranslation();
  const MODES = [
    { id:"REMISE_DIRECTE", label:t("restitution.mode_remise_directe"), desc:t("restitution.mode_remise_directe_desc"), icon:"🤝" },
    { id:"POINT_RELAIS",   label:t("restitution.mode_point_relais"),   desc:t("restitution.mode_point_relais_desc"), icon:"📦" },
    { id:"EXPEDITION",     label:t("restitution.mode_expedition"),     desc:t("restitution.mode_expedition_desc"), icon:"📬" },
    { id:"MANDATAIRE",     label:t("restitution.mode_mandataire"),     desc:t("restitution.mode_mandataire_desc"), icon:"👥" },
  ];
  const { matchingId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const devis = state?.devis || {};

  const [form, setForm] = useState({
    primeAmount: devis.primeAmount || "",
    operator: "MTN",
    mobileMoneyPhone: "",
    restitutionMode: "REMISE_DIRECTE",
    deliveryAddress: "",
  });
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const micro2x = Number(devis.microPaymentAmount || 1000);
  const prime   = Number(form.primeAmount || devis.primeAmount || 2000);
  const logistics = form.restitutionMode === "EXPEDITION" ? 2500 : 0;
  const total = micro2x + prime + logistics;

  const submit = async () => {
    if (!form.mobileMoneyPhone) { toast.error(t("restitution.error_phone_required")); return; }
    if (!form.primeAmount)      { toast.error(t("restitution.error_prime_required")); return; }
    setLoading(true);
    try {
      await restitutionApi.confirmAndPay(matchingId, {
        primeAmount: Number(form.primeAmount),
        operator: form.operator,
        mobileMoneyPhone: form.mobileMoneyPhone,
        restitutionMode: form.restitutionMode,
        deliveryAddress: form.deliveryAddress || null,
      });
      setSuccess(true);
      toast.success(t("restitution.success_toast"));
    } catch (err) {
      toast.error(err.response?.data?.message || t("restitution.error"));
    } finally { setLoading(false); }
  };

  if (success) {
    return (
      <div style={{ minHeight:"100vh", background:"#F7F9FC",
        display:"flex", alignItems:"center", justifyContent:"center",
        padding:"32px", fontFamily:"'DM Sans',sans-serif" }}>
        <div style={{ maxWidth:"480px", width:"100%", textAlign:"center" }}>
          <div style={{ fontSize:"64px", marginBottom:"12px" }}>🎉</div>
          <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"24px",
            fontWeight:700, color:T.gold, marginBottom:"8px" }}>
            {t("restitution.success_title")}</h2>
          <p style={{ color:"#64748B", fontSize:"14px", lineHeight:"1.7", marginBottom:"24px" }}>
            {t("restitution.success_desc")}
          </p>
          <div style={{ background:"#FBF4E8", borderRadius:"12px", padding:"16px",
            marginBottom:"20px", fontSize:"13px", color:"#64748B" }}>
            {t("restitution.success_note")}
          </div>
          <Button variant="gold" full onClick={() => navigate("/dashboard")}>
            {t("restitution.success_cta")}</Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", background:"#F7F9FC", fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.gold},#A67820)`, padding:"16px 32px 28px" }}>
        <div style={{ maxWidth:"680px", margin:"0 auto" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"12px", marginBottom:"16px" }}>
            <button onClick={() => navigate(-1)}
              style={{ background:"rgba(255,255,255,0.2)", border:"none", borderRadius:"10px",
                width:"36px", height:"36px", color:"#fff", cursor:"pointer", fontSize:"16px" }}>←</button>
            <Logo size="sm" white />
          </div>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:"22px",
            color:"#fff", fontWeight:700 }}>{t("restitution.header_title")}</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:"13px", marginTop:"6px" }}>
            {t("restitution.step_label")}</div>
        </div>
      </div>

      <div style={{ maxWidth:"680px", margin:"0 auto", padding:"24px 32px 80px" }}>

        {/* Mode restitution */}
        <p style={{ fontSize:"13px", fontWeight:600, color:"#334155", marginBottom:"10px" }}>
          {t("restitution.mode_label")}</p>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", marginBottom:"20px" }}>
          {MODES.map(mode => (
            <div key={mode.id}
              onClick={() => setForm({ ...form, restitutionMode: mode.id })}
              style={{ padding:"14px", borderRadius:"12px", cursor:"pointer",
                border:`1.5px solid ${form.restitutionMode===mode.id ? T.gold : "#E2E8F0"}`,
                background: form.restitutionMode===mode.id ? "#FBF4E8" : "#fff",
                transition:"all 0.15s" }}>
              <div style={{ fontSize:"20px", marginBottom:"6px" }}>{mode.icon}</div>
              <div style={{ fontSize:"13px", fontWeight:700, color:"#1E293B" }}>{mode.label}</div>
              <div style={{ fontSize:"11px", color:"#64748B", marginTop:"2px" }}>{mode.desc}</div>
            </div>
          ))}
        </div>

        {form.restitutionMode === "EXPEDITION" && (
          <Input label={t("restitution.delivery_address_label")} name="deliveryAddress"
            placeholder={t("restitution.delivery_address_placeholder")}
            value={form.deliveryAddress} onChange={handle} required />
        )}

        {/* Prime */}
        <Input label={t("restitution.prime_label")} name="primeAmount" type="number"
          placeholder={t("restitution.prime_placeholder", { amount: Number(devis.primeAmount||2000).toLocaleString() })}
          value={form.primeAmount} onChange={handle} required
          note={t("restitution.prime_note")} />

        {/* Operateur */}
        <div style={{ marginBottom:"16px" }}>
          <p style={{ fontSize:"13px", fontWeight:600, color:"#334155", marginBottom:"10px" }}>
            {t("restitution.operator_label")}</p>
          <div style={{ display:"flex", gap:"12px" }}>
            {OPERATORS.map(op => (
              <div key={op.id} onClick={() => setForm({ ...form, operator: op.id })}
                style={{ flex:1, padding:"14px 10px", borderRadius:"12px", textAlign:"center",
                  cursor:"pointer", transition:"all 0.15s",
                  border:`2px solid ${form.operator===op.id ? op.color : "#E2E8F0"}`,
                  background: form.operator===op.id ? op.bg : "#fff" }}>
                <div style={{ fontSize:"28px" }}>{op.emoji}</div>
                <div style={{ fontSize:"12px", fontWeight:700, color:"#1E293B", marginTop:"6px" }}>
                  {op.label}</div>
              </div>
            ))}
          </div>
        </div>

        <Input label={t("restitution.phone")} name="mobileMoneyPhone" type="tel"
          placeholder="+237 6 XX XX XX XX"
          value={form.mobileMoneyPhone} onChange={handle} required />

        {/* Total */}
        <div style={{ background:"#fff", borderRadius:"16px",
          border:"1.5px solid #E2E8F0", padding:"18px", marginBottom:"20px" }}>
          {[
            [t("restitution.line_micropayment"), micro2x],
            [t("restitution.line_prime"), prime],
            form.restitutionMode==="EXPEDITION" ? [t("restitution.line_logistics"), 2500] : null,
          ].filter(Boolean).map(([label, amount]) => (
            <div key={label} style={{ display:"flex", justifyContent:"space-between",
              padding:"8px 0", borderBottom:"1px solid #F1F5F9", fontSize:"13px" }}>
              <span style={{ color:"#64748B" }}>{label}</span>
              <span style={{ fontWeight:600 }}>{Number(amount).toLocaleString()} FCFA</span>
            </div>
          ))}
          <div style={{ display:"flex", justifyContent:"space-between",
            paddingTop:"12px", fontSize:"16px" }}>
            <span style={{ fontWeight:800, color:"#1E293B" }}>{t("restitution.total_label")}</span>
            <span style={{ fontWeight:800, color:T.gold, fontSize:"20px" }}>
              {total.toLocaleString()} FCFA</span>
          </div>
        </div>

        <Button variant="gold" full loading={loading}
          disabled={!form.mobileMoneyPhone || !form.primeAmount}
          onClick={submit}>
          {t("restitution.pay_btn", { total: total.toLocaleString() })}
        </Button>
      </div>
      <BottomNav />
    </div>
  );
}